/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CredentialTypeEnum } from './CredentialTypeEnum';
import {
  CredentialTypeEnumFromJSON,
  CredentialTypeEnumFromJSONTyped,
  CredentialTypeEnumToJSON,
} from './CredentialTypeEnum';
import type { TaskTypeEnum } from './TaskTypeEnum';
import { TaskTypeEnumFromJSON, TaskTypeEnumFromJSONTyped, TaskTypeEnumToJSON } from './TaskTypeEnum';

/**
 *
 * @export
 * @interface CredentialWrite
 */
export interface CredentialWrite {
  /**
   *
   * @type {string}
   * @memberof CredentialWrite
   */
  value: string;
  /**
   *
   * @type {string}
   * @memberof CredentialWrite
   */
  name?: string | null;
  /**
   *
   * @type {CredentialTypeEnum}
   * @memberof CredentialWrite
   */
  type?: CredentialTypeEnum | null;
  /**
   *
   * @type {TaskTypeEnum}
   * @memberof CredentialWrite
   */
  taskType?: TaskTypeEnum | null;
}

/**
 * Check if a given object implements the CredentialWrite interface.
 */
export function instanceOfCredentialWrite(value: object): value is CredentialWrite {
  if (!('value' in value) || value['value'] === undefined) return false;
  return true;
}

export function CredentialWriteFromJSON(json: any): CredentialWrite {
  return CredentialWriteFromJSONTyped(json, false);
}

export function CredentialWriteFromJSONTyped(json: any, ignoreDiscriminator: boolean): CredentialWrite {
  if (json == null) {
    return json;
  }
  return {
    value: json['value'],
    name: json['name'] == null ? undefined : json['name'],
    type: json['type'] == null ? undefined : CredentialTypeEnumFromJSON(json['type']),
    taskType: json['task_type'] == null ? undefined : TaskTypeEnumFromJSON(json['task_type']),
  };
}

export function CredentialWriteToJSON(value?: CredentialWrite | null): any {
  if (value == null) {
    return value;
  }
  return {
    value: value['value'],
    name: value['name'],
    type: CredentialTypeEnumToJSON(value['type']),
    task_type: TaskTypeEnumToJSON(value['taskType']),
  };
}
